import { api } from '@/lib/api'

/* ------------------------------------------------------------------
   گفتگو — Rocket.Chat داخلِ پنل
   ------------------------------------------------------------------
   ⚠️ هیچ توکنی از اینجا نمی‌آید. ورود از راهِ OAuth است: پنل
   «سرورِ ورود» است و Rocket.Chat خودش از آن می‌پرسد کاربر کیست.
   ------------------------------------------------------------------ */

export interface ChatConfig {
  enabled: boolean
  /** نشانیِ سرورِ گفتگو، بی‌اسلشِ پایانی — `https://chat.kanzcard.com` */
  url: string | null
  /** نامِ سرویسِ Custom OAuth در Rocket.Chat؛ null یعنی ورودِ خودکار تنظیم نشده. */
  sso_service: string | null
}

export const chatApi = {
  config: async (): Promise<ChatConfig> => {
    const response = await api.get<{ data: ChatConfig }>('/me/chat')
    return response.data.data
  },
}
